'use client'

import { useEffect } from 'react'
import { useAnalytics } from '~/hooks/use-analytics'

/**
 * Tự động track click cho bất kỳ element nào có data-track attribute.
 *
 * Cách dùng trong JSX:
 *   <button data-track="signup_clicked" data-track-source="homepage">Đăng ký</button>
 *   <a data-track="banner_click" data-track-banner="summer_sale">...</a>
 *
 * Quy tắc đặt tên property:
 *   data-track-source   → { source: "..." }
 *   data-track-banner   → { banner: "..." }
 *   data-track-section  → { section: "..." }
 */
export function DataAttributeTracker() {
  const { trackEvent } = useAnalytics()

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const el = (e.target as HTMLElement).closest('[data-track]') as HTMLElement | null
      if (!el) return

      const eventName = el.dataset.track
      if (!eventName) return

      const properties: Record<string, string> = {}
      Object.keys(el.dataset).forEach((key) => {
        if (key !== 'track' && key.startsWith('track')) {
          // dataTrackSource → source, dataTrackBannerName → bannerName
          const prop = key.replace('track', '').replace(/^./, (c) => c.toLowerCase())
          properties[prop] = el.dataset[key]!
        }
      })

      trackEvent(eventName, properties)
    }

    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [trackEvent])

  return null
}
